export default {
    "Version": "2017.01.19.01",
    "URL": "http://fullclientus.dragonnest.com/Rawfile/",
    "TotalCount": 38,
    "TotalSize": 8003165400,
    "FileList": [
      {
        "Name": "bdcap32.dll",
        "Size": 7661040,
        "CheckSum": "793F2349C9772874BED2789CFD247103"
      },
      {
        "Name": "bdvid32.dll",
        "Size": 5718016,
        "CheckSum": "4A9AA8CB9188496ADB573C704DAF2E81"
      },
      {
        "Name": "codec_TCS16.dll",
        "Size": 831488,
        "CheckSum": "507F9F00D71163D50E3AF3CD219AF837"
      },
      {
        "Name": "codec_TCS8.dll",
        "Size": 831488,
        "CheckSum": "E1F536596F8B2F27CD9DFD9E58A55690"
      },
      {
        "Name": "d3dx9d_31.dll",
        "Size": 4161816,
        "CheckSum": "A3139DBEE991144D348C1C0D3E11887D"
      },
      {
        "Name": "d3dx9_31.dll",
        "Size": 2414360,
        "CheckSum": "797E24743937D67D69F28F2CF5052EE8"
      },
      {
        "Name": "DnEndingBanner.exe",
        "Size": 360032,
        "CheckSum": "1DB81DF4C474A8622F1CF2910EF12D79"
      },
      {
        "Name": "DNLauncher.exe",
        "Size": 1269344,
        "CheckSum": "112EAE0B8B2CBFCFC46E9B06B252EEAC"
      },
      {
        "Name": "DragonNest.exe",
        "Size": 19357280,
        "CheckSum": "4C621CDA8BCA830E0DF070D72BB4390F"
      },
      {
        "Name": "fmodex.dll",
        "Size": 374784,
        "CheckSum": "B5E73EF421CEEF3EDD3A4EC11ABEFCB5"
      },
      {
        "Name": "iceclientlib.dll",
        "Size": 4333568,
        "CheckSum": "CD05B4F43BAD33918A9F8C3CB32D66B7"
      },
      {
        "Name": "nmcogame.dll",
        "Size": 362744,
        "CheckSum": "FD12E45DA67B7418255EDDB90F5FE225"
      },
      {
        "Name": "nmconew.dll",
        "Size": 2017528,
        "CheckSum": "FDD015BC411D9AA937003FC9ECD6530D"
      },
      {
        "Name": "Resource00.pak",
        "Size": 545154041,
        "CheckSum": "6E78222C27151A92AE50CC745D89D945"
      },
      {
        "Name": "Resource01.pak",
        "Size": 541010630,
        "CheckSum": "2A56CFDC7F3B86789A8018E21EA74FBB"
      },
      {
        "Name": "Resource02.pak",
        "Size": 553500753,
        "CheckSum": "F9E9C2FA567E194020CD90F1924C9F22"
      },
      {
        "Name": "Resource03.pak",
        "Size": 537418724,
        "CheckSum": "CDFE0FAC86F7BD60AD3CBC4C3222135B"
      },
      {
        "Name": "Resource04.pak",
        "Size": 537018201,
        "CheckSum": "5FEFE8CEF224D4784B02AF1E18B23282"
      },
      {
        "Name": "Resource05.pak",
        "Size": 540844445,
        "CheckSum": "007953740E8C56014871BAC0F69C23A2"
      },
      {
        "Name": "Resource06.pak",
        "Size": 546561053,
        "CheckSum": "DF7A286881064D122DA01997BD453732"
      },
      {
        "Name": "Resource07.pak",
        "Size": 544370095,
        "CheckSum": "E2C13E6DCCDFE850F9D8737C56A60217"
      },
      {
        "Name": "Resource08.pak",
        "Size": 542711155,
        "CheckSum": "3192EBC2E0DA7282FFD940E00CBAEDF3"
      },
      {
        "Name": "Resource09.pak",
        "Size": 538264375,
        "CheckSum": "176B576136A497AE9BC15DC241521989"
      },
      {
        "Name": "Resource10.pak",
        "Size": 538278888,
        "CheckSum": "11C0DD9177F0F771014249007D76F386"
      },
      {
        "Name": "Resource11.pak",
        "Size": 539313871,
        "CheckSum": "D4591807F199DDD33D47C20A02474275"
      },
      {
        "Name": "Resource12.pak",
        "Size": 539290606,
        "CheckSum": "97CC90EE68E3CF43A751FCFEAAB6F000"
      },
      {
        "Name": "Resource13.pak",
        "Size": 540083123,
        "CheckSum": "67CD7AAD64DC2CDBA5E183AC2594D386"
      },
      {
        "Name": "Resource14.pak",
        "Size": 353794316,
        "CheckSum": "123355B1729C4FFDDCEEEC9C8197EEEE"
      },
      {
        "Name": "rmakeresult.txt",
        "Size": 4,
        "CheckSum": "504621802AD758C38B7853BF42EAC13C"
      },
      {
        "Name": "SecureEngineConfig.ini",
        "Size": 75,
        "CheckSum": "0BEDC12441DDBEF2DE4160E1570B4256"
      },
      {
        "Name": "steam_api.dll",
        "Size": 105808,
        "CheckSum": "E5578450156D19260FC06E2A72856595"
      },
      {
        "Name": "vcredist_x86.exe",
        "Size": 2705744,
        "CheckSum": "C5C698758BD9DA02CC2EF94DCF1B4637"
      },
      {
        "Name": "Version.cfg",
        "Size": 13,
        "CheckSum": "07B2C790E7A8F90A834898639EF80833"
      },
      {
        "Name": "WindowsInstaller.exe",
        "Size": 2585872,
        "CheckSum": "342F79337765760AD4E392EB67D5ED2C"
      },
      {
        "Name": "XIGNCODE/x3.xem",
        "Size": 2275048,
        "CheckSum": "8CFD755CDB9330B29B3CAB9E7564B7E4"
      },
      {
        "Name": "XIGNCODE/xcorona.xem",
        "Size": 3228024,
        "CheckSum": "A8CDA6F6D76A03E3911C94D11C956C03"
      },
      {
        "Name": "XIGNCODE/xcorona_x64.xem",
        "Size": 4047736,
        "CheckSum": "21B1CBA7A3E4378A9624EE6E619E6B91"
      },
      {
        "Name": "XIGNCODE/xnina.xem",
        "Size": 909312,
        "CheckSum": "8B42922370D5F40BDB6358338D108B97"
      }
    ]
  }
  